module.exports = __webpack_public_path__ + "static/one-8bd5d663518acbaeaf48e08b2aac0bf4.svg";